<template>
  <div :class="curClass" :style="curStyle">
    <slot />
  </div>
</template>

<script>
import classNames from 'utils/classNames';

export default {
  name: 'simple-space',
  props: {
    size: {
      type: [Array, String],
      default: function () {
        return [8, 8];
      },
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    prefixCls: {
      type: String,
      default: 'simple-space',
    },
  },
  computed: {
    curStyle() {
      let columnGap, rowGap;
      switch (typeof this.size) {
        case 'string':
          columnGap = `${this.size}px`;
          rowGap = `${this.size}px`;
          break;
        case 'object':
          columnGap = `${this.size[0]}px`;
          rowGap = `${this.size[this.size.length - 1]}px`;
      }
      return {
        columnGap,
        rowGap,
      };
    },
    curClass() {
      return classNames(`${this.prefixCls}`, `${this.prefixCls}-${this.direction}`);
    },
  },
};
</script>

<style scoped lang="scss">
.simple-space {
  display: flex;
  flex-wrap: wrap;

  &-vertical {
    flex-direction: column;
  }
}
</style>
